export default __webpack_public_path__ + "static/media/commission.3764a4fc.svg";